'use client';

import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

/**
 * Back-to-Top floating button for blog posts.
 * Appears after scrolling 400px down. Critical for mobile UX on long blog posts.
 *
 * EEAT Signal: Trustworthiness (good UX = quality site signal)
 */
export default function BackToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollToTop}
      aria-label="Yukarı çık"
      className={`fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-hzc_purple_500 text-white shadow-lg flex items-center justify-center transition-all duration-300 hover:bg-hzc_purple_600 hover:scale-110 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <ArrowUp size={20} />
    </button>
  );
}
